<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-flower-tulip" icon-small title="لیست اعلام واریزی ها" color="accent">
			<template v-slot:beforeBody>
				<div class="text-left mb-4 px-5">
					<v-btn color="primary" small dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						اعلام واریزی جدید
					</v-btn>
				</div>
			</template>
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
							single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :headers="headers" :loading="loading" :items="items" :items-per-page="500" :search="search"
							class="elevation-1">
							<template v-slot:item.loanPayment.userLoanModel.loanModel.title="{ item }">
								<div>{{ item.loanPayment.userLoanModel.loanModel.title }}</div>
								<div class="grey--text text-small">کد: {{ item.loanPayment.userLoanModel.code }}</div>
							</template>
							<template v-slot:item.loanPayment.installmentNumber="{ item }">
								<div>قسط شماره: {{ item.loanPayment.installmentNumber }}</div>
								<div class="grey--text text-small">سررسید: {{ item.loanPayment.targetMonth_Persian.date }}</div>
								<div class="grey--text text-small">مبلغ هر قسط:
									{{ item.loanPayment.userLoanModel.installment.toString().toPriceFormat() }}</div>
							</template>
							<template v-slot:item.amount="{ item }">
								{{ item.amount.toString().toPriceFormat() }}
							</template>
							<template v-slot:item.str_Status="{ item }">
								<div :style="{ color: statusColor(item.status) }">{{ item.str_Status }}</div>
								<div v-if="item.adminDescription">
									<a href="javascript:void(0)" @click="showAdminDescription(item.adminDescription)">مشاهده توضیحات
										ادمین</a>
								</div>
							</template>
							<template v-slot:item.operations="{ item }">
								<v-btn class="mx-1" fab dark small color="secondary" @click="edit(item)">
									<v-icon dark>
										mdi-square-edit-outline
									</v-icon>
								</v-btn>
								<v-btn class="mx-1" fab dark small color="pink" @click="remove(item)">
									<v-icon dark>
										mdi-trash-can-outline
									</v-icon>
								</v-btn>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>

			<v-dialog v-model="dialog" scrollable persistent max-width="800px">
				<v-card>
					<v-card-title>
						<div><span class="headline">مشخصات واریزی</span></div>
						<v-spacer />
						<v-btn @click="dialog = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<modify-payment-request ref="modifyPaymentRequest" v-if="dialog" :isAdmin="false" :data="selectedItem"
								@callbck="callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="adminDescriptionDialog" scrollable persistent max-width="800px">
				<v-card>
					<v-card-title>
						<div><span class="headline">توضیحات ادمین</span></div>
						<v-spacer />
						<v-btn @click="adminDescriptionDialog = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<p style="white-space:pre">
								{{ adminDescription }}
							</p>
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import ModifyLoanPaymentRequest from '@/components/forms/ModifyLoanPaymentRequest.vue'

	export default {
		name: 'LoanRequestsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-payment-request': ModifyLoanPaymentRequest,
		},
		data() {
			return {
				adminDescription: '',
				adminDescriptionDialog: false,
				loading: false,
				errorMessages: '',
				localData: {},
				selectedItem: {},
				dialog: false,
				search: '',
				headers: [
					{
						text: 'نام وام',
						align: 'start',
						sortable: true,
						value: 'loanPayment.userLoanModel.loanModel.title',
					}, {
						text: 'مشخصات قسط',
						align: 'center',
						sortable: true,
						value: 'loanPayment.installmentNumber',
					}, {
						text: 'تاریخ واریز',
						align: 'center',
						sortable: true,
						value: 'paymentDate_Persian.date',
					}, {
						text: 'مبلغ واریزی',
						align: 'center',
						sortable: true,
						value: 'amount',
					}, {
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'str_Status',
					}, {
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						value: 'operations',
						width: 150,
					},
				],
				items: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('member/userLoanPaymentRequest/list', null)
					.then(
						response => {
							this.loading = false
							this.items = response
						})
					.catch(err => {
						this.loading = false
						toast.error(err.message)
					})
			},
			add() {
				this.dialog = true
				this.selectedItem = { id: emptyId }
			},
			edit(item) {
				this.dialog = true
				this.selectedItem = item
			},
			callbck(result) {
				this.dialog = false
				if (result) { this.loadData() }
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('member/userLoanPaymentRequest/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			statusColor(status) {
				switch (status) {
					case 1:
						return 'green'
					case 2:
						return 'red'
					default:
						return 'orange'
				}
			},
			statusIcon(status) {
				switch (status) {
					case 1:
						return 'mdi-account-check-outline'
					case 2:
						return 'mdi-account-cancel-outline'
					default:
						return 'mdi-account-clock-outline'
				}
			},
			showAdminDescription(description) {
				this.adminDescription = description
				this.adminDescriptionDialog = true
			}
		},
	}
</script>
<style></style>
